import { annuitycalculatorV1 } from "./annuitycalculator-v1";
import { annuitycalculatorV3 } from "./annuitycalculator-v3";
import { costOfDelayCalculator } from "./cost-of-delay-calculator";
import { drawdowncalculatorV1 } from "./drawdowncalculator-v1";
import { LanderV2CampaignConfig } from "./types";

export const landerV2Registry: Record<string, LanderV2CampaignConfig> = {
  "annuitycalculator-ux2-vlm3": annuitycalculatorV1,
  "annuitycalculator-ux2-vlm1": annuitycalculatorV3,
  "drawdowncalculator-ux2-v1": drawdowncalculatorV1,
  "cost-of-delay-calculator": costOfDelayCalculator,
};

export function isLanderV2CampaignValid(slug: string | undefined): boolean {
  return !!slug && slug in landerV2Registry;
}

export function getLanderV2Campaign(
  slug: string | undefined
): LanderV2CampaignConfig | undefined {
  if (!slug) return undefined;
  return landerV2Registry[slug];
}
